import './add.less';

import React from 'react';
import {Button, Modal} from 'antd';
import {ManagersAddForm} from './forms/add';
import {addManager} from '../../../helpers/api';
import {inject, observer} from 'mobx-react/index';


@inject("usersStore")
@observer
export class ManagersAdd extends React.Component {
  state = {
    loading: false,
    exists: null,
    data: {}
  };

  render() {
    return (
      <Modal
        visible={true}
        onCancel={::this.onCancel}
        title="Добавление менеджера"
        footer={false} >
        <div className="managers-add">
          <ManagersAddForm loading={this.state.loading} submit={::this.submit} cancel={::this.onCancel} />
        </div>
      </Modal>
    );
  }

  onCancel() {
    this.props.history.goBack();
  }

  async submit(data) {
    console.log('submit data', data);
    this.setState({ loading: true });

    const ok = await this.props.usersStore.add({ email: data.username, password: data.password });
    if(ok) {
      this.props.history.goBack();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/admin/add.js